import regression from 'regression';

import {DEFAULT_VALUE, POS_NEG_LINE} from 'util/constants';
import {getNow} from 'util/utils';

const ONE_DAY = 1;
const ONE_MONTH = 1;
const INDEX_PRED = 1;

export const getMonth = month => {
    const date = new Date(month);

    return date.getMonth();
};

export const getNextMonth = () => {
    const newDate = new Date();

    newDate.setMonth(newDate.getMonth() + ONE_MONTH);

    return newDate.getTime();
};

export const createMonthForecast = spendingByVendor => {
    if (spendingByVendor && spendingByVendor.data.length) {
        const now = new Date(getNow());
        const lastDay = new Date(now);

        lastDay.setMonth(lastDay.getMonth() + ONE_MONTH);
        lastDay.setDate(DEFAULT_VALUE);
        const maxDays = lastDay.getDate();

        const data = spendingByVendor.data.slice();

        for (let i = spendingByVendor.data.length + ONE_DAY; i <= maxDays; i++) {
            const dayForecast = module.exports.createDayForecast(data);

            data.push({
                step:   i,
                amount: dayForecast
            });
        }

        return data.reduce((ret, item) => ret + item.amount, DEFAULT_VALUE);
    }

    return undefined;
};

export const createDayForecast = spendingByVendor => {
    if (spendingByVendor && spendingByVendor.length) {
        const seeds = spendingByVendor.map(item => [item.step, item.amount]);

        const value = regression.linear(seeds).predict(seeds.length + ONE_DAY)[INDEX_PRED];

        if (value < POS_NEG_LINE) {
            return spendingByVendor.slice().pop().amount;
        }

        return value;
    }

    return DEFAULT_VALUE;
};

export const createMonthsForecast = (last12Months, numMonths) => {
    if (last12Months && last12Months.length) {
        const seeds = module.exports.createMonthsTemplate(last12Months, numMonths);

        const value = regression.linear(seeds).predict(seeds.length + ONE_DAY)[INDEX_PRED];

        if (value < POS_NEG_LINE) {
            return DEFAULT_VALUE;
        }

        return value;
    }

    return undefined;
};

export const getPrevious = last12Months => {
    if (last12Months && last12Months.data.length) {
        const today = new Date(getNow());
        const monthToday = today.getMonth();
        const last12MonthsCopy = last12Months.data.slice();
        let last = last12MonthsCopy.pop();
        const date = new Date(last.month);
        const monthDate = date.getMonth();

        if (monthToday === monthDate) {
            last = last12MonthsCopy.pop();
        }

        return last ? last.amount : DEFAULT_VALUE;
    }

    return undefined;
};

export const createData = (last12Months, spendingByVendor) => {
    const POSITION_SEED_CURRENT = 11;
    const POSITION_SEED_NEXT = 12;
    const POSITION_SEED_NEXT2 = 13;

    if (last12Months && spendingByVendor) {
        let filteredLast = last12Months;
        const nextMonth = module.exports.getNextMonth();

        if (spendingByVendor.length) {
            filteredLast = last12Months
                .filter(itemLast => spendingByVendor
                    .find(itemBy => itemLast.vendor.code === itemBy.entity.code));
        }

        return filteredLast
            .map(item => {
                const spendingByVendorItem = spendingByVendor.find(itemBy => item.vendor.code === itemBy.entity.code);

                const previous = module.exports.getPrevious(item);
                let current = DEFAULT_VALUE;

                if (spendingByVendorItem) {
                    current = module.exports.createMonthForecast(spendingByVendorItem);
                } else {
                    current = module.exports.createMonthsForecast(item.data.slice(), POSITION_SEED_CURRENT);
                }

                let currentDiff, next, nextDiff, next2, next2Diff;

                if (previous) {
                    currentDiff = current - previous;

                    const last12Forecast = item.data.slice();

                    if (last12Forecast.length) {
                        const last12ForecastItem = last12Forecast.pop();

                        last12Forecast.push({
                            ...last12ForecastItem,
                            amount: current
                        });

                        next = module.exports.createMonthsForecast(last12Forecast, POSITION_SEED_NEXT);

                        nextDiff = next - current;

                        const last13Months = last12Forecast.slice();

                        last13Months.push({
                            month:  nextMonth,
                            amount: next
                        });

                        next2 = module.exports.createMonthsForecast(last13Months, POSITION_SEED_NEXT2);

                        next2Diff = next2 - next;
                    }
                } else {
                    currentDiff = current;
                }

                return {
                    vendor: item.vendor,
                    current, currentDiff,
                    next, nextDiff,
                    next2, next2Diff
                };
            });
    }

    return [];
};


/**
 * Calculate the predictions
 * @param {Array} vendorAmounts The amounts of a vendor
 * @return {Array} The prediction value
 */
const NUM_MONTHS = 12;

export const createMonthsTemplate = (last12Months, numMonths = NUM_MONTHS) => {
    const template = [];
    const currentDate = new Date(getNow());

    while (template.length < numMonths) {
        const item = last12Months.find(_item => {
            const date = new Date(_item.month);

            return date.getMonth() === currentDate.getMonth() &&
                date.getFullYear() === currentDate.getFullYear();
        });

        const index = numMonths - template.length - ONE_MONTH;

        template.unshift([index, item ? item.amount : DEFAULT_VALUE]);

        currentDate.setMonth(currentDate.getMonth() - ONE_MONTH);
    }

    return template;
};



// WEBPACK FOOTER //
// ./src/util/dashboard.js